import { getDeferred } from './resource';

const defaultMsg = getDeferred('ISNOTVALID');
const msgs = {
    lettersOnly: getDeferred('LETTERSONLY'),
    numbersOnly: getDeferred('NUMBERSONLY'),
    notDefault: getDeferred('PLEASEENTERREQUIRED'),
    required: getDeferred('PLEASEENTERREQUIRED'),
    requiredIf: getDeferred('PLEASEENTERREQUIRED'),
    notDefaultIf: getDeferred('PLEASEENTERREQUIRED'),
    requiredGuest: getDeferred('PLEASEENTERREQUIRED'),
    email: getDeferred('MUSTBEEMAIL'),
    flightNumber: getDeferred('MUSTBEFLIGHTNUMBER'),
    ageCheck: getDeferred('MUSTMATCHDATEOFBIRTH'),
    oneMainDriver: getDeferred('MUSTHAVEONEDRIVER'),
    numberOfAdditionalDrivers: getDeferred('NUMBEROFADDITIONALDRIVERSMUSTEQUAL'),
    mustPassCreditCheck: getDeferred('MUSTPASSCREDITCHECK'),
    emailAllowed: getDeferred('MUSTBEVALIDEMAILFORDOMAIN')
};

export function translateField(field, e, map) {
    return translateFieldLabel(field.label, e, map);
}

export function translateFieldLabel(label, e, map) {
    let msg = defaultMsg();

    if (map && map[e]) {
        msg = map[e];
    } else if (msgs[e]) {
        msg = msgs[e]();
    }

    if (e === 'dobcheck') {
        label = '';
    }

    if (msg.indexOf('{0}') !== -1) {
        msg = String.format(msg, label || '');
    } else {
        msg = (label ? `${label} ` : '') + msg;
    }

    return msg;
}
